import { Section, SectionTitle } from './shared'

import TagList from '../../../components/display/TagList'
import Tag from '../../../components/display/Tag'

export default ({ listing, isDesktop, ...props }) => (
  <Section {...props}>
    <SectionTitle>Features and Amenities</SectionTitle>
    <TagList limit={isDesktop ? 10 : 6}>
      {listing.amenities.map((a) => (
        <Tag key={a.slug} icon={a.slug} disabled={!a.available}>
          {a.name}
        </Tag>
      ))}
    </TagList>
  </Section>
)
